import script from "./PgmUserInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./PgmUserInfo.vue?vue&type=script&setup=true&lang=ts"

import "./PgmUserInfo.vue?vue&type=style&index=0&id=7c056c3b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c056c3b"]])

export default __exports__